import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=588b110f&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588b110f')) {
      api.createRecord('588b110f', component.options)
    } else {
      api.reload('588b110f', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=588b110f&", function () {
      api.rerender('588b110f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Si36eypDqa1c/JS/comp/ErrorMessage.vue"
export default component.exports